import BasicInfoTab from './basic-info-tab'

export default BasicInfoTab
